module.exports = __webpack_public_path__ + "static/media/VOSB_symbol.ff4794d7.png";